<template>
  <div id="control-bar">
    <div v-for='(key, index) in keys' :key='index' class="wrapper-key">
      <div v-if="key.text"><span class="text">{{key.text}}</span><span class="action">{{key.action}}</span></div>
      <div v-else><span class="square" :class="'square-' + key.color"></span><span class="action">{{key.action}}</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ControlBar',
  props: ['keys']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
#control-bar
  position: fixed
  left: 0
  bottom: 0
  width: 100%
  min-height: 2.4rem
  background-color: #000
  color: #fff
  padding-left: 1.7rem
  padding: .3rem
  font-size: .8rem
  border-top: 1px solid white

  display: flex
  flex-direction: row
  align-items: center

  .wrapper-key
    display: inline-block
    margin-left: 40px

    .text

    .action
      margin-left: 8px

    .square
      float: left
      width: 20px
      height: 20px
      border: 1px solid rgba(0, 0, 0, .2)

    .square-red
      background-color: red

    .square-green
      background-color: green

    .square-yellow
      background-color: yellow

    .square-blue
      background-color: blue

</style>



// WEBPACK FOOTER //
// src/components/ControlBar.vue